var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M39.5 20C39.5 28.6662 33.8432 36.0144 26.0206 38.5519V24.9263H29.8334H30.273L30.3293 24.4903L30.9756 19.4826L31.0484 18.9186H30.4797H26.0206V16.2292C26.0206 15.5275 26.1243 15.0767 26.3632 14.793C26.5858 14.5285 27.0259 14.2973 27.9962 14.2973H30.625H31.125V13.7973V9.33075V8.89274L30.6908 8.8351C30.2086 8.77108 28.6171 8.63391 26.7728 8.63391C24.7652 8.63391 23.0229 9.24806 21.7811 10.4755C20.5377 11.7046 19.8516 13.4935 19.8516 15.7336V18.9186H16.0547H15.5547V19.4186V24.4263V24.9263H16.0547H19.8516V39.4994C9.152 39.4196 0.5 30.7183 0.5 20C0.5 9.23214 9.23214 0.5 20 0.5C30.7679 0.5 39.5 9.23214 39.5 20Z","fill":"black","stroke":"black"}));
}

FacebookIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
